import { Image, ImageProps } from '@drone-js/core';
import React, { SyntheticEvent } from 'react';
import { useSelector } from 'react-redux';
import { selectPageTypeIdFromBootstrap } from 'store/slice/bootstrap';
import { countImageLoadingFailures } from 'store/api/measurements/commonMeasurements';

/*
todo : remove this post pix integration as pix supports query params
 */
const ActivityImage: React.FC<ImageProps> = (props: ImageProps) => {
    const { alt, ...imageProps } = props;
    const pageTypeId = useSelector(selectPageTypeIdFromBootstrap);

    const onError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
        const target = e.target as HTMLImageElement;
        if (target) {
            countImageLoadingFailures('loadActivityImage', pageTypeId, target.src);
        }
        props.onError?.(e);
    };

    return <Image responsive="original" alt={alt} onError={onError} {...imageProps} />;
};

ActivityImage.displayName = 'ActivityImage';
export { ActivityImage };
